import { v4 as uuid } from 'uuid';
import { initAnalytics, StateAnalyticsParams } from './analytics/analytics';
import { updateGdprApplies, getCookieByName } from './init.utils';
import { markPerformance } from './performance';
import { ErrorReporter } from './errorReporter.type';

export type CoreParams = StateAnalyticsParams;

function initSessionId() {
  const thirtyMinutes = 30 * 60;
  const sessionId = getCookieByName('mm-session-id');
  if (sessionId) {
    document.cookie = `mm-session-id=${sessionId}; max-age=${thirtyMinutes}; path=/`;
  } else {
    const newSessionId = uuid();
    document.cookie = `mm-session-id=${newSessionId}; max-age=${thirtyMinutes}; path=/`;
  }
}

export function init(params: CoreParams, errorProvider: ErrorReporter) {
  try {
    initSessionId();
    initAnalytics(params);
    markPerformance('init-analytics');
  } catch (e) {
    errorProvider.reportException(e);
  }
  try {
    updateGdprApplies();
  } catch (e) {
    errorProvider.reportException(e);
  }
}
